export default "__VITE_ASSET__D9dhshK1__"